module.exports = __webpack_public_path__ + "static/Napollo-3dad901538260627d14fffaa9b6bef50.png";